// Constants
// Actions
import { CompleteTrackedInteractionAction, StartTrackedInteractionAction, ViewRenderAction } from "@ms/planner-actions/lib/local/performanceCollection/PerformanceCollectionAction";
import { MarkerTag } from "@ms/uno-telemetry/lib/local/performance/constants/PerformanceMarkerConstants";
export class PerformanceCollectionModule {
    setViewRenderState(viewId, state, extraData) {
        this.dispatcher.dispatchActionAsync(new ViewRenderAction(viewId, state, extraData));
    }
    startTrackedInteraction(name, startTime, targetViewId, completionStrategy, extraData) {
        this.dispatcher.dispatchActionAsync(new StartTrackedInteractionAction(name, startTime, targetViewId, completionStrategy, extraData));
    }
    completeTrackedInteraction(targetViewId) {
        this.dispatcher.dispatchActionAsync(new CompleteTrackedInteractionAction(targetViewId));
    }
    logInteraction(startTime, name, endMode, extraData) {
        const duration = performance.now() - startTime;
        // Log as performance mark (flows through existing telemetry pipeline)
        // Target thresholds (metTarget) are computed in Kusto, not client-side
        this.performanceMarker.mark(MarkerTag.UserInteraction, {
            ...extraData,
            name,
            duration: String(Math.round(duration)),
            endMode
        });
    }
    constructor(dispatcher, performanceMarker){
        this.dispatcher = dispatcher;
        this.performanceMarker = performanceMarker;
    }
}
